import { translate } from "app/filters/i18nFilter";

import type { ICheckboxFilterOption } from "../components/filters/CheckboxFilter/types";
import type { FilterValueDelta } from "../types/misc";
import { calculateArrayDelta } from "../utils/calculateValueDeltaUtils";

import { FilterPanelBaseFilter } from "./BaseFilter";

export class CheckboxFilterModel<T extends string = string> extends FilterPanelBaseFilter<
    readonly T[],
    readonly ICheckboxFilterOption<T>[]
> {
    constructor(rawOptions: readonly T[], translationPrefix: string) {
        const options = rawOptions.map((rawOption) => ({
            label: translate(`${translationPrefix}.${rawOption}`),
            value: rawOption,
        }));

        super({ options });
    }

    calculateValueDelta(previousValue?: readonly T[], newValue?: readonly T[]): FilterValueDelta<T> {
        return calculateArrayDelta(previousValue, newValue);
    }
}
